import { render, staticRenderFns } from "./WastePercent.vue?vue&type=template&id=fda51ffe&scoped=true"
import script from "./WastePercent.vue?vue&type=script&lang=ts"
export * from "./WastePercent.vue?vue&type=script&lang=ts"
import style0 from "./WastePercent.vue?vue&type=style&index=0&id=fda51ffe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fda51ffe",
  null
  
)

export default component.exports